import { notification as antNotification } from 'antd';
import { playSuccessSound, playErrorSound, playWarningSound } from './soundUtils';

// Create a wrapper that mimics the Ant Design notification API
const audioNotification = {
  success: (config) => {
    playSuccessSound();
    return antNotification.success(config);
  },
  error: (config) => {
    playErrorSound();
    return antNotification.error(config);
  },
  warning: (config) => {
    playWarningSound();
    return antNotification.warning(config);
  },
  info: (config) => {
    return antNotification.info(config);
  },
  open: (config) => {
    if (config.type === 'success') playSuccessSound();
    else if (config.type === 'error') playErrorSound();
    else if (config.type === 'warning') playWarningSound();
    return antNotification.open(config);
  },
  close: (key) => {
    return antNotification.close(key);
  },
  destroy: (key) => {
    return antNotification.destroy(key);
  }
};

// For backwards compatibility, export individual methods
export const notificationSuccess = (config) => {
  playSuccessSound();
  return antNotification.success(config);
};

export const notificationError = (config) => {
  playErrorSound();
  return antNotification.error(config);
};

export const notificationWarning = (config) => {
  playWarningSound();
  return antNotification.warning(config);
};

export const notificationInfo = (config) => {
  return antNotification.info(config);
};

export { audioNotification }; 